import { SettingsDialogDataProvider } from '../SettingsDialog';

const fallback = () => {
  console.error('Incorrect SettingsDialogDataProvider usage.');
  return Promise.reject();
};

const avatarFallback = {
  getAvatar: fallback,
  getName: fallback,
  resolveId: fallback,
  saveAvatar: fallback,
  deleteAvatar: fallback,
};

const fallbackSettingsDialogDataProvider: SettingsDialogDataProvider = {
  getCustomThemes: fallback,
  getSystemThemes: fallback,
  getDefaultTheme: fallback,
  ...avatarFallback,
};

export default fallbackSettingsDialogDataProvider;
